export var PartnerStatusEnum;
(function (PartnerStatusEnum) {
    PartnerStatusEnum[PartnerStatusEnum["Active"] = 0] = "Active";
    PartnerStatusEnum[PartnerStatusEnum["Inactive"] = 1] = "Inactive";
})(PartnerStatusEnum || (PartnerStatusEnum = {}));
